import { render, staticRenderFns } from "./WaveGuideDialog.vue?vue&type=template&id=28d51e66&scoped=true"
import script from "./WaveGuideDialog.vue?vue&type=script&lang=js"
export * from "./WaveGuideDialog.vue?vue&type=script&lang=js"
import style0 from "./WaveGuideDialog.vue?vue&type=style&index=0&id=28d51e66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d51e66",
  null
  
)

export default component.exports